const streenTheme = {
  //characterEditing:  
  colors: {
    primary: '#00d8ff',
    secondary: '#0090c8',
    thirdColor: '#b7f2fd',
    success: '#52c41a',
    danger: '#f5222d',
    warning: '#faad14',
    info: '#1890ff',
    light: '#f8f9fa',
    dark: '#343a40',
    red: '#B0161B',
    blueShade: '#40BFB0', 
    olive1: '#7B973D', 
    blue: '#45BDB7',
    pink: '#CB5872' ,
    purple: '#75466C',
    yellow: '#EBA913' ,
    selectedEnrichment: '#7D8750',
    background: '#fdf6e7',
    background2: '#f7d491',
    black: '#000000'
    
  },
  fonts: {
    // family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    smallSize: '12px',
    textSize1: '14px',   
    textSize2: '16px',
    heading: '24px',
    subHeading1: '18px',  
    subHeading2: '22px', // || 22px   
    subTitleSize: '28px',    
    TitleSize: '32px',
    family: "quicksand"

  }
}
export default streenTheme;